// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__dVFsc","footer":"ChangeClinic_footer__1bojZ"};